import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TipoProducto } from 'src/app/models/cobertura.model';

@Component({
    selector: 'app-producto-detalle',
    templateUrl: './producto-detalle.component.html',
    styleUrls: ['./producto-detalle.component.scss']
})
export class ProductoDetalleComponent implements OnInit {

    tipoProducto: TipoProducto = 'VIVIENDA';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.tipoProducto = params['tipo'] === 'comercial' ? 'COMERCIAL' : 'VIVIENDA';
        });
    }

    get titulo(): string {
        return this.tipoProducto === 'VIVIENDA' ? 'Vivienda' : 'Comercial';
    }

    get descripcion(): string {
        const tipo = this.tipoProducto === 'VIVIENDA' ? 'vivienda' : 'comercial';
        return `Configuración de fianzas, coberturas y servicios contratados de ${tipo} por zona.`;
    }
}
